// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from "react";
import { PlasmicLogoutModal } from "./plasmic/cps/PlasmicLogoutModal";
import { compose, lifecycle, withHandlers, withState } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { showLogoutModal } from "../redux/reducers/view";
import { authUserRequest, logoutUserRequest } from "../redux/reducers/login";

function LogoutModal_(props, ref) {
 
  return (
    <div>
      {props.view.showLogoutModal && <div style={{height:'100%', width:'100%', position:'absolute', top:0, left:0, zIndex:100000}}>
      <PlasmicLogoutModal root={{ ref }} {...props} 
        btnYes={{
          onClick:(e)=>{
            props.getAuthUser()
            props.showLogoutModal(false)
      
          }
        }}
        btnNo={{
          onClick:(e)=>{
            props.showLogoutModal(false)
            props.logout(true)
          }
        }}
       
        btnClose={{
          onClick:(e)=>{
            props.showLogoutModal(false)
          }
        }}
      />
      </div>}
      </div>
  );
}

const LogoutModal = React.forwardRef(LogoutModal_);

const mapStateToProps = state => ({
  loginReducer: state.loginReducer,
  view: state.viewReducer,
});
const mapDispatchToProps = dispatch => ({
  
  showLogoutModal: bool => dispatch(showLogoutModal(bool)),
  getAuthUser: bool => dispatch(authUserRequest(bool)),
  logout: bool => dispatch(logoutUserRequest(bool)),
});


export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withRouter
)(LogoutModal);

